import { QueryClient } from '@tanstack/react-query'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60 * 1000,
			cacheTime: 15 * 60 * 1000,
			refetchOnWindowFocus: false,
			retry: 1
		},
		mutations: {
			retry: 1
		}
	}
})

export default queryClient
